'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getValueFromEvent = getValueFromEvent;
exports.checkIsRequired = checkIsRequired;
function getValueFromEvent(e) {
  // support custom element
  if (!e || !e.target) {
    return e;
  }
  var target = e.target;

  return target.type === 'checkbox' ? target.checked : target.value;
}

function checkIsRequired(rules) {
  if (rules) {
    if (Array.isArray(rules)) return rules.filter(function (_ref) {
      var required = _ref.required;
      return required;
    }).length > 0;
    return !!rules.required;
  }
  return false;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/rc-mobx-form/lib/utils.js
// module id = 253
// module chunks = 0